import * as yup from "yup";
import { createEmailSchema, createRequiredTrimmedString } from "./schemaUtils";

export const schema = yup
  .object({
    first_name: createRequiredTrimmedString("First name is required"),
    last_name: createRequiredTrimmedString("Last name is required"),
    email: createEmailSchema({
      requiredMessage: "Email Address is required",
      invalidMessage: "Invalid email address",
    }),
  })
  .required();

export const internalInviteSchema= yup
.object({
  user: createRequiredTrimmedString("Please select user")
})
.required();
